import { Inventory } from "store/types/inventory.store.types";

export enum CLOUD_MAP_TYPES {
  ACCOUNTS = "accounts",
  ASSETS = "assets",
}

export type CloudMapSupportedTypes = Inventory;
